// This file is auto-generated by CS->TS converter

import { HttpParams, HttpUrlEncodingCodec } from "@angular/common/http";
import { RequestExtraConfig } from "./RequestExtraConfig";

export class CustomEncoder extends HttpUrlEncodingCodec {

    encodeValue(value: string) {

        return super.encodeValue(value).replace("+", "%2B");
    }
}

export class RequestParams {

    private httpParams: HttpParams & { interceptorConfig?: RequestExtraConfig };
    private config: RequestExtraConfig;

    constructor(config: RequestExtraConfig) {

        this.httpParams = new HttpParams({ encoder: new CustomEncoder() });
        this.config = config;
    }

    toHttpParams() {

        this.httpParams.interceptorConfig = this.config;
        return this.httpParams;
    }

    setList<T>(name: string, list: T[]) {

        if (list) {

            list.forEach(value => {

                if (value?.toString) this.httpParams = this.httpParams.append(name, value.toString());
            });
        }
    }

    setValue<T>(name: string, value: T) {

        if (value?.toString) {

            this.httpParams = this.httpParams.set(name, value.toString());
        }
    }
}
